import { async } from '@angular/core/testing';
import { AlertService } from './../../core/services/alert.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from 'app/auth/service';
import { ERROR } from 'dropzone';
import { TokenOAuth } from '../models/token-oauth';
import { User } from '../models';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private request: HttpRequest<any> = null;
  private next: HttpHandler = null;
  errorsGetforfront: any = null;

  /**
   *
   * @param {AuthenticationService} _authenticationService
   */
  constructor(
    private _authenticationService: AuthenticationService,
    private alert: AlertService
  ) {}

  /**
   * Add auth header with jwt if user is logged in and request is to api url
   * @param request
   * @param next
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.processIntercept(request, next);
  }

  private processRefreshToken(refresh_token: string) {
    this._authenticationService.setTokenOAuth(null);
    this._authenticationService.authenticate(refresh_token, true).subscribe(
      data => {
        var tokenOAuth = new TokenOAuth(data.tokenOAuthResponse);
        this._authenticationService.setTokenOAuth(tokenOAuth);
        console.log('vai processar novamente.....');
        console.log(this.request);
        console.log(this.next);
        //this.processIntercept(request, next);
      },
      (e: HttpErrorResponse) => {
        this.alert
          .exibirAlert(
            'Sua sessão na ferramenta expirou e você foi desconectado!',
            'USEREXPIRED'
          )
          .then(res => {
            location.href =
              'https://login.microsoftonline.com/common/oauth2/v2.0/logout';
          });
      }
    );
  }

  private processIntercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const tokenOAuth: TokenOAuth = this._authenticationService.tokenOAuthValue;
    const isApiUrl = request.url.startsWith(process.env.APIURL);
    let intercepted = false;
    if (tokenOAuth && isApiUrl) {
      const user: User = this._authenticationService.currentUserValue;
      let currentCompany = null;
      if (user != null) {
        currentCompany = user.empresaId;
      }
      const isApiUrlPerfil = request.url.startsWith(
        process.env.APIURL + 'api/perfil'
      );
      if (isApiUrlPerfil == false) {
        intercepted = true;
      }
      this.request = request;
      this.next = next;
      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${tokenOAuth.access_token}`,
          company: currentCompany != null ? currentCompany.toString() : '',
        },
      });
    }
    return next.handle(request).pipe(
      catchError(err => {
        if ([401, 403].indexOf(err.status) !== -1) {
          if (intercepted) {
            console.log(
              'a requisicao apresentou um 401 e sera requisitado um novo token...'
            );
            this.processRefreshToken(tokenOAuth.refresh_token);
          }
        } else {
          const isApiMidia = request.url.startsWith(
            process.env.APIURL + 'api/app'
          );
          if (isApiMidia == true) {
            console.log('Erro ao obter a url do app');
            console.log(err);
          }
        }
        return throwError(err);
      })
    );
  }
}

